import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center overflow-auto mt-4 mt-sm-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ligipaasetavus = _resolveComponent("Ligipaasetavus")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        style: {"overflow-y":"auto","height":"100%"},
        class: "pt-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Ligipaasetavus)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}